// extracted by mini-css-extract-plugin
export var button = "_12-1";
export var featuredLink = "_12-4";
export var spinner = "_12-2";
export var spinnerContainer = "_12-3";
export var text = "_12-0";